/**
 * OrbDocCoreConceptsTraitsENOrbDocCoreConceptsTraitsENPage
 *
 * Page component for OrbDocCoreConceptsTraitsENOrbDocCoreConceptsTraitsENPage
 * Path: /docs/core-concepts/traits
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { OrbDocCoreConceptsTraitsENDocScreenView as __OrbDocCoreConceptsTraitsENDocScreenView } from '@/components/traits/OrbDocCoreConceptsTraitsENDocScreenView';
import { OrbDocCoreConceptsTraitsENDocAnalyticsView as __OrbDocCoreConceptsTraitsENDocAnalyticsView } from '@/components/traits/OrbDocCoreConceptsTraitsENDocAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { SharedEntityStoreContext, useSharedEntityStore, usePageHead } from '@almadar/ui/hooks';

interface OrbDocCoreConceptsTraitsENOrbDocCoreConceptsTraitsENPageProps {
  // Add any page-level props here
}

export function OrbDocCoreConceptsTraitsENOrbDocCoreConceptsTraitsENPage(_props: OrbDocCoreConceptsTraitsENOrbDocCoreConceptsTraitsENPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":"Traits","description":"State machines that react to events, check guards, run effects and render the screen.","access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/docs/core-concepts/traits"},{"locale":"ar","path":"/ar/docs/core-concepts/traits"},{"locale":"sl","path":"/sl/docs/core-concepts/traits"}],"defaultLocale":"en", path: __location.pathname });

  const _sharedStore = useSharedEntityStore();

  return (
    <SharedEntityStoreContext.Provider value={_sharedStore}>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__OrbDocCoreConceptsTraitsENDocScreenView config={{ initPayload: __navState }} />
          <__OrbDocCoreConceptsTraitsENDocAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </SharedEntityStoreContext.Provider>
  );
}

export default OrbDocCoreConceptsTraitsENOrbDocCoreConceptsTraitsENPage;
